import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { BreakpointProvider } from "@/utils/breakpoints/breakpoints.provider";

import { DeviceFingerPrintingProvider } from "../Product/Reviews/context/deviceFingerPrinting.context";
import { ReviewsContextProvider } from "../Product/Reviews/context/reviews.context";
import { WriteReviewContextProvider } from "../Product/Reviews/context/writeReview.context";
import { useProductPageContext } from "./context/productPage.context";

type ProductPageProvidersProps = {};

export const ProductPageProviders = ({
    children
}: RequireChildrenFor<ProductPageProvidersProps>) => {
    const { product, totalReviews, reviews, reviewsSummary } =
        useProductPageContext();

    return (
        <DeviceFingerPrintingProvider>
            <ReviewsContextProvider
                sku={product.sku}
                brand={product.brand?.name || ""}
                category={product.superCategoryName}
                initialTotalReviews={totalReviews}
                initialReviews={reviews}
                summary={reviewsSummary}
            >
                <WriteReviewContextProvider sku={product.sku}>
                    <BreakpointProvider>{children}</BreakpointProvider>
                </WriteReviewContextProvider>
            </ReviewsContextProvider>
        </DeviceFingerPrintingProvider>
    );
};
